import { Component, OnInit, Inject } from '@angular/core';
import { SectorService } from '../../../@core/services/sector.service';
import { RouteService } from '../../../@core/services/route.service';
import { RouteModel } from '../../../@core/models/route';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA
} from '@angular/material/dialog';
import { AuthenticationService } from '../../../@core/services/authentication.service';
import { ApiProvider } from '../../../@core/providers/api.provider';
import { MobileUser } from '../../../@core/models/MobileUser';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ngx-driver-dialog',
  templateUrl: './driver-dialog.component.html',
  styleUrls: ['./driver-dialog.component.scss']
})
export class DriverDialogComponent implements OnInit {
  public RouteID: number;
  public RouteModel: RouteModel;
  public email: string;
  public checked: boolean;
  public password: string = '';
  public passwordconfirm: string = '';
  public driverlanguage: string = 'fr';
  public error: string = undefined;

  constructor(
    public _sectorService: SectorService,
    public dialog: MatDialog,
    public authenticationService: AuthenticationService,
    public _routeService: RouteService,
    private apiProvider: ApiProvider,
    private translate: TranslateService,
    private dialogRef: MatDialogRef<DriverDialogComponent>
  ) {
    this.RouteModel = this._routeService.currentRouteValue;
  }

  ngOnInit() {
    // this._routeService.initialiseRoute(this.RouteID);
    this.driverlanguage =
      this._routeService.currentRouteValue &&
      this._routeService.currentRouteValue.RouteDriverLanguage
        ? this._routeService.currentRouteValue.RouteDriverLanguage
        : 'fr';
  }

  ngAfterViewInit() {}

  public cancelClick() {
    this.dialogRef.close(null);
  }

  public sendClick() {
    this.error = undefined;
    if (this._routeService.currentRouteValue.RouteDriverName === null)
      this._routeService.currentRouteValue.RouteDriverName = '';

    if (this._routeService.currentRouteValue.RouteDriverPhone === null)
      this._routeService.currentRouteValue.RouteDriverPhone = '';

    this.apiProvider
      .driverExists(this._routeService.currentRouteValue.RouteDriverName)
      .subscribe(
        (result: boolean) => {
          if (result) {
            this._routeService.updateRoute(
              this._routeService.currentRouteValue.RouteID,
              this._routeService.currentRouteValue.RouteDriverName,
              this._routeService.currentRouteValue.RouteDriverPhone,
              this._routeService.currentRouteValue.RouteDriverLanguage
            );
            if (
              this.password === '' ||
              (this.password != '' && this.passwordconfirm === this.password)
            ) {
              let CurrentAccount: MobileUser = new MobileUser();

              if (this.password !== "") {
                CurrentAccount.Password = this.password;
              }

              CurrentAccount.firstname = this._routeService.currentRouteValue.RouteDriverName;
              CurrentAccount.RouteId = this._routeService.currentRouteValue.RouteID;
              CurrentAccount.UserName = this._routeService.currentRouteValue.RouteDriverName;
              CurrentAccount.RouteIds = this._routeService.currentRouteValue.MobileUser.RouteIds;

              this.apiProvider.updateDriver(CurrentAccount).subscribe(
                (route: boolean) => {},
                (err: HttpErrorResponse) => {}
              );

              this.dialogRef.close(
                this._routeService.currentRouteValue.RouteDriverName
              );
            } else {
              this.error = this.translate.instant(
                'driver-dialog.password-match-error'
              );
            }
          } else {
            this.error = this.translate.instant(
              'driver-dialog.driver-not-found'
            );
          }
        },
        (err: HttpErrorResponse) => {}
      );
  }

  public routeChange(routeID: number): void {
    if (!this._routeService.currentRouteValue.MobileUser) {
      this._routeService.currentRouteValue.MobileUser = new MobileUser();
    }

    let index = this._routeService.currentRouteValue.MobileUser.RouteIds.indexOf(
      routeID
    );
    if (index !== -1) {
      this._routeService.currentRouteValue.MobileUser.RouteIds.splice(index, 1);
    } else {
      this._routeService.currentRouteValue.MobileUser.RouteIds.push(routeID);
    }
  }
}
